import { isBaseScheduleBlank } from "./temporaryAssignmentInputValidation";

export const employeeInfoErrorsInitialState = {
  contactNumberErrors: "",
  startDateErrors: "",
  endDateErrors: "",
  commentErrors: "",
};

export const baseScheduleInitialState = {
  SUN: {
    start: {
      hr: "",
      min: "",
    },
    end: {
      hr: "",
      min: "",
    },
    isOFF: false,
    isNA: false,
  },
  MON: {
    start: {
      hr: "",
      min: "",
    },
    end: {
      hr: "",
      min: "",
    },
    isOFF: false,
    isNA: false,
  },
  TUE: {
    start: {
      hr: "",
      min: "",
    },
    end: {
      hr: "",
      min: "",
    },
    isOFF: false,
    isNA: false,
  },
  WED: {
    start: {
      hr: "",
      min: "",
    },
    end: {
      hr: "",
      min: "",
    },
    isOFF: false,
    isNA: false,
  },
  THU: {
    start: {
      hr: "",
      min: "",
    },
    end: {
      hr: "",
      min: "",
    },
    isOFF: false,
    isNA: false,
  },
  FRI: {
    start: {
      hr: "",
      min: "",
    },
    end: {
      hr: "",
      min: "",
    },
    isOFF: false,
    isNA: false,
  },
  SAT: {
    start: {
      hr: "",
      min: "",
    },
    end: {
      hr: "",
      min: "",
    },
    isOFF: false,
    isNA: false,
  },
};

export const baseScheduleApplyToAllFilterInitialState = {
  start: {
    hr: "",
    min: "",
  },
  end: {
    hr: "",
    min: "",
  },
};

export const baseScheduleErrorsInitialState = {
  SUN: {
    error: "",
  },
  MON: {
    error: "",
  },
  TUE: {
    error: "",
  },
  WED: {
    error: "",
  },
  THU: {
    error: "",
  },
  FRI: {
    error: "",
  },
  SAT: {
    error: "",
  },
  fullScheduleError: "",
};

export const isBaseScheduleAdded = (baseSchedule) => {
  return baseSchedule && Object.keys(baseSchedule).length > 0 && !isBaseScheduleBlank(baseSchedule);
};
